import type { MatchScore } from '~/modules/get-matched/utils/match-buildhub-project';

const FIELD_LABELS: Record<string, string> = {
    projectScope: 'project scope',
    region: 'region',
    budget: 'budget',
    timeline: 'timeline',
};

interface StepMatchProjectProps {
    match: MatchScore;
    onAccept: () => void;
    onSkip: () => void;
}

export const StepMatchProject = ({
    match,
    onAccept,
    onSkip,
}: StepMatchProjectProps) => {
    const matchedLabels = match.matchedFields
        .map((f) => FIELD_LABELS[f] ?? f)
        .join(', ');

    return (
        <div className="flex flex-col gap-[1.375rem]">
            <h2 className="text-[1.3125rem] font-medium uppercase leading-[1.1] tracking-[-0.02em] text-[#161616]">
                Are you enquiring for{' '}
                <span className="text-[#00599c]">{match.project.Title}</span>?
            </h2>
            <p className="text-[0.875rem] leading-[1.3] tracking-[-0.02em] text-[#161616]">
                We noticed your brief looks like one of your existing projects.
                Matched on: <span className="font-medium">{matchedLabels}</span>
                .
            </p>
            <p className="text-[0.75rem] leading-[1.2] tracking-[-0.02em] text-[#858585]">
                Choosing &ldquo;Yes&rdquo; will pre-fill the rest of your brief
                with details from this project. You can still edit anything
                before submitting.
            </p>
            <div className="flex flex-col gap-2 pt-2">
                <button
                    type="button"
                    onClick={onAccept}
                    className="inline-flex h-[2.85rem] items-center justify-center rounded-full bg-[#323232] px-9 text-[1rem] font-medium tracking-[0.02em] text-white shadow-md transition-colors hover:bg-black"
                >
                    Yes — use those details
                </button>
                <button
                    type="button"
                    onClick={onSkip}
                    className="inline-flex h-[2.85rem] items-center justify-center rounded-full border border-[#858585] bg-transparent px-9 text-[1rem] font-medium tracking-[0.02em] text-[#161616] transition-colors hover:bg-[#f5f5f5]"
                >
                    No, this is a different enquiry
                </button>
            </div>
        </div>
    );
};
